import 'react';
import { TruCheckCircle, TruCheck, TruThumbDown, TruCross, TruThumbUp, TruTick, TruBullet } from '@uswitch/spark-icons/tru';
import { jsx } from 'theme-ui/jsx-runtime';

var ICONS = {
  'check-circle': {
    icon: jsx(TruCheckCircle, {})
  },
  checklist: {
    icon: jsx(TruCheck, {})
  },
  cons: {
    icon: jsx(TruThumbDown, {})
  },
  cross: {
    icon: jsx(TruCross, {}),
    color: 'error'
  },
  pros: {
    icon: jsx(TruThumbUp, {})
  },
  'thumb-down': {
    icon: jsx(TruThumbDown, {}),
    color: 'error'
  },
  'thumb-up': {
    icon: jsx(TruThumbUp, {}),
    color: 'success'
  },
  tick: {
    icon: jsx(TruTick, {}),
    color: 'success'
  },
  bullet: {
    icon: jsx(TruBullet, {}),
    color: 'grey-100'
  }
};

export { ICONS as default };
